import type { TOC } from '@ember/component/template-only';
import PowerSelect from 'ember-power-select/components/power-select';

interface DateRangeSelectorSignature {
  Args: {
    selectedDateRange?: string;
    dateRangeFilterOptions: string[];
    onDateRangeSelect: (selected: string) => void;
    dropdownClass?: string;
    triggerClass?: string;
  };
  Element: HTMLElement;
}

export default <template>
  <PowerSelect
    @selected={{@selectedDateRange}}
    @searchEnabled={{false}}
    @options={{@dateRangeFilterOptions}}
    @onChange={{@onDateRangeSelect}}
    @renderInPlace={{true}}
    @dropdownClass={{@dropdownClass}}
    @triggerClass={{@triggerClass}}
    data-test-date-range-selector
    ...attributes
    as |option|
  >
    {{option}}
  </PowerSelect>
</template> satisfies TOC<DateRangeSelectorSignature>;
